var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"Notifications"}}),(!_vm.internetStatus.connection || _vm.internetStatus.speed < 0.5)?_c('internet-message',{attrs:{"internetStatus":_vm.internetStatus}}):_vm._e(),_c('router-view'),_c('ActionModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }